const registerUser = async (userData) => {
  try {
    const res = await fetch(`/api/v1/users/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userData),
    });

    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.message || "Failed to register user");
    }
  } catch (error) {
    throw new Error(`Registration error: ${error.message}`);
  }
};

const loginUser = async (userData) => {
  try {
    const res = await fetch(`/api/v1/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userData),
    });

    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.message || "Login failed");
    }

    const {
      data: { user, token },
    } = await res.json();

    localStorage.setItem("authToken", token);
    localStorage.setItem("authUser", JSON.stringify(user));

    return { user, token };
  } catch (error) {
    throw new Error(`Login error: ${error.message}`);
  }
};

const verifyToken = async (token) => {
  try {
    const res = await fetch(`/api/v1/auth/verify-token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.message || "Token verification failed");
    }

    const response = await res.json();
    console.log("Backend token response:", response);
    return response;
  } catch (error) {
    throw new Error(`Token verification error: ${error.message}`);
  }
};

// const sendVerificationEmail = async (email) => {
//   try {
//     const res = await fetch("/api/v1/auth/send-verification-email", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ email }),
//     });
//
//     if (!res.ok) {
//       const errorData = await res.json();
//       throw new Error(errorData.message || "Failed to send verification email");
//     }
//   } catch (error) {
//     throw new Error(`Email sending error: ${error.message}`);
//   }
// };

const sendVerificationEmail = async (email) => {
  try {
    const res = await fetch(
      "https://us-central1-rise-lean-uat.cloudfunctions.net/sendVerificationEmailToUsers",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email,
          // uid: user.uid // UID is not passed as per requirement/snippet
        }),
      }
    );

    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(errorText || "Failed to send verification email");
    }

    // Attempt to parse JSON if exists, otherwise return raw
    try {
      return await res.json();
    } catch (e) {
      return {};
    }
  } catch (error) {
    throw new Error(`Email sending error: ${error.message}`);
  }
};

// New OTP and Setup Flow Functions

const sendOtp = async (email) => {
  try {
    const res = await fetch(
      "https://us-central1-rise-lean-uat.cloudfunctions.net/sendOtp", 
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      }
    );

    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(errorText || "Failed to send OTP");
    }
    return await res.json();
  } catch (error) {
    throw new Error(`OTP Send Error: ${error.message}`);
  }
};

const verifyOtp = async (email, otp, newPassword = null) => {
  try {
    const body = { email, otp };
    if (newPassword) {
      body.newPassword = newPassword;
    }

    const res = await fetch(
      "https://us-central1-rise-lean-uat.cloudfunctions.net/verifyOtp",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }
    );

    const data = await res.json();
    if (!res.ok || !data.success) {
      throw new Error(data.message || "Failed to verify OTP");
    }
    return data;
  } catch (error) {
    throw error instanceof Error ? error : new Error(String(error));
  }
};

const sendSetupEmail = async (data) => {
  // data: { email, firstName, lastName }
  try {
    // Note: URL might change based on backend implementation
    const res = await fetch(
      "https://us-central1-rise-lean-uat.cloudfunctions.net/sendAccountSetupEmail", // Using existing URL for now, backend logic should change to send Link
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    );

    if (!res.ok) {
      throw new Error("Failed to send setup email");
    }
    return await res.json(); // or text()
  } catch (error) {
    console.warn("Setup email warning:", error);
    // Suppress error to not block UI if payment succeeded? 
    // Better to throw so UI shows warning.
    throw error;
  }
};

export default {
  registerUser,
  loginUser,
  verifyToken,
  sendVerificationEmail,
  sendOtp,
  verifyOtp,
  sendSetupEmail
};
